(function() {
    'use strict';


    var loadZipData = function(callback) {
        var ajax = new XMLHttpRequest();
        ajax.open('GET', '//eweb8.vfd2-testnet.de/api/vfd2dyn/json/direktvertrieb/geo.json', true);
        ajax.onreadystatechange = function () {
            if (ajax.readyState === XMLHttpRequest.DONE && 200 === ajax.status) {
                callback(JSON.parse(ajax.responseText));
            }
        };
        ajax.send();
    };

    var areThereJobsProvided = function(jobs) {
        if (0 === jobs.length) {
            return false;
        }
        return true;
    };

    /**
     *
     * @param {object} roles
     * @param {array} jobs
     */
    var getProperNamesForJobs = function(roles, jobs) {
        var index;
	    for (var prop in roles) {
	        index = jobs.indexOf(prop);
	        if (-1 < index) {
            jobs[index] = roles[prop];
        }
    }
        console.log(jobs);
        return jobs;
		//var teamleiter = jobs.indexOf
    };

    var getHtmlListforProperJobs = function(jobs, city) {
        var ul = document.createElement('ul');
		//document.getElementById('myList').appendChild(ul);

        jobs.forEach(function(job){
            var li = document.createElement('li');
            ul.appendChild(li);
            li.innerHTML = '<a href="' + job.linkToPdf + '" class="link1a" target="_blank" rel="noopener noreferrer"><svg class="i-xsml svg1a"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/simplicity/svgdefs.svg#i-arrow-right-sml"></use></svg>' + job.name + ' (m/w/d) für den Standort ' + city + '</a>';
        });

        return ul;
    };

    var getHtmlHeadlineForProperJobs = function(amountOfJobs, zip, city) {
        var div = document.createElement('div');
        div.classList.add('h2');
        div.innerHTML = amountOfJobs + ' Jobs in ' + zip + ' ' + city + ' und Umgebung';
        return div;
    };

    var init = function(context) {

        var s = vf['direktvertrieb-plzsearch'].settings;
        var zipData;
        $(s.target, context).addBack(s.target).each(function() {
            var $this = $(this);

            var addMapSize = function() {
                var mapWidth = $this.find('.imgBox').css('width');
                var mapHeight = Math.round(parseInt(mapWidth) * 1.3484848484848);

                $this.find('#map').css({ width: mapWidth, height: mapHeight + 'px' });
            };

            $(window).on('vf::resize', addMapSize);
            addMapSize();


            var zipInput = $(this).find('#zip');
            var searchButton = $(this).find('#search');
            var pin = $(this).find('#pin');
            var map = $(this).find('#map');
            var errorMessage = $(this).find('#jobs');
            var jobsMessage = $(this).find('#jobs');

            zipInput.on('keyup', function(e) {

                var code = e.which;
                if (13 === code) {
                    e.preventDefault();
                    searchButton.trigger('click');
                }

            });

            loadZipData(function(data) {
                zipData = data;
                searchButton.removeClass('disabled');
            });



            searchButton.on('click', function() {
                var defaultBackgroundImageName = '//eweb8.vfd2-testnet.de/media/img/direktvertrieb/base.png';
                map.css('background-image', 'url("' + defaultBackgroundImageName + '")');
                pin.css({'left': 0, 'top': 0, 'display': 'none'});
                errorMessage.text('');
                jobsMessage.text('');
                var zip = zipInput.val();
                if (false === /[0-9]{5}/.test(zip)) {
                    errorMessage.text('keine gültige PLZ');
                    return;
                }

                var entry = zipData[zip];
                if (!entry) {
                    errorMessage.text('Leider konnten wir diese Postleitzahl keinem Vertriebsgebiet zuordnen.');
                    return;
                }

                if (false === areThereJobsProvided(entry.j)) {
                    jobsMessage.html('Leider sind wir in diesem Gebiet noch nicht tätig. Du bist umzugsbereit in eines unserer Vertriebsgebiete? Dann bewirb Dich einfach unten. Wenn das für Dich nicht möglich ist, schreib <a href="mailto:beratenzuhause.de@vodafone.com" style="text-decoration:underline;">uns eine Mail</a>, Du kannst auch für eine unserer Agenturen tätig werden.');
                } else {
                    var properNames = getProperNamesForJobs(s.roles, entry.j);

                    getHtmlListforProperJobs(properNames, entry.ort);


                    jobsMessage.append(getHtmlHeadlineForProperJobs(properNames.length, entry.plz, entry.ort));
                    jobsMessage.append(getHtmlListforProperJobs(properNames, entry.ort));
                    jobsMessage.append('<a class="ws2-btn arrow"><span>Bewirb Dich jetzt</span> <svg class="i-sml i-red link-arrow"><use xlink:href="/simplicity/svgdefs.svg#i-arrow-ws2-right-sml"></use></svg></a>');


                    $('.arrow').on('click', function() {

                        var target = $('#bewirbdichjetzt');
                        var heightNavigation = $('.main-nav').height();

                        $('html,body').animate({
                            scrollTop: target.offset().top - heightNavigation
                        }, 800);
                    });

                }

                var imageName = '//eweb8.vfd2-testnet.de/media/img/direktvertrieb/vg_' + entry.vg + '.png';
                map.css('background-image', 'url("' + imageName + '")');
                var left = 'calc(' + entry.x + '% - ' + (pin.width() / 2) + 'px)';
                var top = 'calc(' + entry.y + '% - ' + (pin.height() / 2) + 'px)';
                pin.css({'left': left, 'top': top, 'display': 'block'});

            });



        });
    };
    vf['direktvertrieb-plzsearch'] = {
        settings: {
            target: '.mod-direktvertrieb-plzsearch',
            roles: {
                'T': {
                    'name': 'Vodafone-Teamleiter',
                    'linkToPdf': 'https://eweb8.vfd2-testnet.de/media/downloads/pdf/stellenanzeige-teamleiter.pdf'
                },
                'A': {
                    'name': 'Teamleiter-Anwärter',
                    'linkToPdf': 'https://eweb8.vfd2-testnet.de/media/downloads/pdf/stellenanzeige-teamleiter-anwaerter.pdf'
                },
                'M': {
                    'name': 'Vodafone-Mentor',
                    'linkToPdf': 'https://eweb8.vfd2-testnet.de/media/downloads/pdf/stellenanzeige-mentor.pdf'
                },
                'S': {
                    'name': 'Senior Vodafone-Berater',
                    'linkToPdf': 'https://eweb8.vfd2-testnet.de/media/downloads/pdf/stellenanzeige-senior-berater.pdf'
                },
                'V': {
                    'name': 'Junior Vodafone-Berater',
                    'linkToPdf': 'https://eweb8.vfd2-testnet.de/media/downloads/pdf/stellenanzeige-junior-berater.pdf'
                },
                'UM1': {
                    'name': 'Vodafone-Berater',
                    'linkToPdf': 'https://eweb8.vfd2-testnet.de/media/downloads/pdf/stellenanzeige-vodafone-berater.pdf'
                }
            }
        },
        init: init

    };
}(vf));
